import React, {useState} from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {WHITE, FOCUS_BLUE} from '../../../shared/style/colors';
import SimpleButton from '../../../shared/library/buttons/base/simple';
import {PHONE} from '../../../shared/style/breakpoints';
import {useSendAnalyticsEvent} from '../../../shared/enhancers/analytics-enhancer';
import {WEIGHT} from '../../../shared/style/typography';
import StackShareEnterpriseForm from '../../../shared/library/stackshare-enterprise-form';

const ButtonContainer = glamorous(SimpleButton)(
  {
    border: `1px solid #008FF9`,
    borderRadius: 4,
    height: 58,
    fontSize: 20,
    fontWeight: WEIGHT.ULTRA_BOLD,
    textAlign: 'center',
    backgroundColor: FOCUS_BLUE,
    color: WHITE,
    padding: '0 41px',
    minWidth: 'auto',
    letterSpacing: 0,
    [PHONE]: {
      width: '100%',
      height: 58,
      fontSize: 20,
      fontWeight: 600
    }
  },
  ({extraStyle}) => (extraStyle ? extraStyle : {})
);

const RequestDemo = ({text = 'Request a Demo', extraStyle, eventProperties}) => {
  const [isLeadFormOpen, setLeadFormOpen] = useState(false);
  const sendAnalyticsEvent = useSendAnalyticsEvent();

  return (
    <>
      <ButtonContainer
        onClick={() => {
          setLeadFormOpen(true);
          sendAnalyticsEvent('request_demo', {
            ...eventProperties
          });
        }}
        extraStyle={extraStyle}
      >
        {text}
      </ButtonContainer>
      {isLeadFormOpen && (
        <StackShareEnterpriseForm
          onDismiss={() => setLeadFormOpen(false)}
          title="Have questions before you sign up?"
          type="lead"
        />
      )}
    </>
  );
};

RequestDemo.propTypes = {
  text: PropTypes.string,
  extraStyle: PropTypes.object,
  eventProperties: PropTypes.object
};

export default RequestDemo;
